import fade from 'liquid-fire/transitions/fade';

export default function (opts) {
  return fade.call(this, opts).then(() => this.newElement.querySelector('[autofocus]')?.focus());
}
